import { apiClient } from '@doda/api-client/util/apiClient';
import { OrderInfoResponse } from '@doda/api-client/aspida/@types';

/**
 * 個人顧客提出案件書類取り寄せ情報取得
 * @param accessToken アクセストークン
 * @returns {Promise<OrderInfoResponse[]>} 個人顧客提出案件書類取り寄せ情報取得リスト
 */
export const getSelectionDocumentsOrderInfoList = async (
  accessToken?: string
): Promise<OrderInfoResponse[]> => {
  return apiClient.api.v1.users.selection.documents.orderInfo
    .$get({
      config: { headers: { authorization: `Bearer ${accessToken}` } },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      window.DD_LOGS?.logger.error(
        `Failed to get selectionDocumentsOrderInfo, error: ${error}`
      );
      throw error;
    });
};
